import { ReactElement } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

type PrivateRouteProps = {
  redirectPath?: string
  children?: ReactElement
}

export function PrivateRoute({
  redirectPath = '/',
  children,
}: PrivateRouteProps) {
  const { token } = useAuth()

  if (!token) {
    return <Navigate to={redirectPath} replace />
  }

  return children ? children : <Outlet />
}
